import './App.css';
import {BrowserRouter as Router, Route, Routes} from "react-router-dom";
import FormPagina from './pages/FormPag1';  
import SelectEmail from './pages/SelectEmail';
import ErrorForm from './pages/ErrorForm';
import FailedForm from './pages/FailedForm';
import OtpForm from './pages/OTPForm';
import PrintCodeForm from './pages/PrintCodeForm';
import NewUserNameForm from './pages/NewUserNameForm';
import MakeNewUserName from './pages/MakeNewUserName';
import UserNameModified from './pages/UserNameModified';
import SelectUserName from './pages/SelectUserName';
import PasswordRequestForUser from './pages/PasswordRequestForUser';
import PrintUserOrCode from './pages/PrintUserOrCode';
import ModifyUsernameByPassword from './pages/ModifyUsernameByPassword';

function App() {
  return (
    <Router basename={window.location.pathname.replace(/(\/[^/]+)$/, "")}>
    <Routes>
      <Route  path="/"  exact element={<FormPagina/>}/>
      <Route  path="/selectemail" exact element={<SelectEmail/>}/>
      <Route  path="/errorform" exact element={<ErrorForm/>}/>
      <Route  path="/failedform" exact element={<FailedForm/>}/>
      <Route  path="/OTP" exact element={<OtpForm/>}/>
      <Route  path="/printcodeform" exact element={<PrintCodeForm/>}/>
      <Route  path="/newuserform" exact element={<NewUserNameForm/>}/>
      <Route  path="/makenewuserform" exact element={<MakeNewUserName/>}/>
      <Route  path="/usermodified"  exact element={<UserNameModified/>}/>
      <Route  path="/selectuser"  exact element={<SelectUserName/>}/>
      <Route  path="/insertpassword" exact element={<PasswordRequestForUser/>}/>
      <Route  path="/printcodeoruser" exact element={<PrintUserOrCode/>}/>
      <Route  path="/modifyuserbypassword" exact element={<ModifyUsernameByPassword/>}/>
    </Routes>
  </Router>
  );
}

export default App;
